import classnames from 'classnames'
import PropTypes from 'prop-types'

import Logo from '../../../../shared_components/Logo'
import MobileHeaderEverplansBrandedCobranding from '../../../../shared_components/everplans_branded_cobranding/MobileHeaderEverplansBrandedCobranding'

import {
  useOrganizationCobranding
} from '../../../../shared_components/OrganizationCobrandingContext'

import OrganizationCobrandingHeaderLogo from '../../../../shared_components/header/OrganizationCobrandingHeaderLogo'

import {
  hasEverplansCobranding,
  hasOrganizationCobranding
} from '../../../../lib/cobrandingTools'

import './navHeader.scss'

const NavHeader = ({
  bannerClassNames,
  cobranding = {}
}) => {
  const organizationCobranding = useOrganizationCobranding()

  return (
    <header className={classnames('nav-header flex-child', bannerClassNames)}>
      {hasOrganizationCobranding(organizationCobranding) ?
        <OrganizationCobrandingHeaderLogo
          includeEverplansLogo={true}
          organizationCobranding={organizationCobranding}
        /> :
        <a href='#/dashboard'><Logo /></a>}
      {hasEverplansCobranding(cobranding) &&
      <MobileHeaderEverplansBrandedCobranding cobranding={cobranding} />}
    </header>
  )
}

NavHeader.propTypes = {
  bannerClassNames: PropTypes.string,
  cobranding: PropTypes.object
}

export default NavHeader
